"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const tutorial_form_types_1 = require("@front/types/tutorial-form.types");
const TutorialStepsHelper_1 = require("./helpers/TutorialStepsHelper");
const TutorialDataHelper_1 = require("./helpers/TutorialDataHelper");
const TutorialScanHelper_1 = require("./helpers/TutorialScanHelper");
const TutorialSaveHelper_1 = require("./helpers/TutorialSaveHelper");
const TutorialChatHelper_1 = require("./helpers/TutorialChatHelper");
const TutorialFormEventsHelper_1 = require("./helpers/TutorialFormEventsHelper");
require("@front/components/tutorial-slide-nav/component");
require("@front/components/tutorial-slide-section-nav/component");
require("@front/components/ai-form-editor/component");
const tutorial_form_types_2 = require("@front/types/tutorial-form.types");
const components_1 = require("@rws-framework/components");
components_1.RWSModal;
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => x.showOnboarding, (0, fast_element_1.html) `
<tutorial-onboarding-wizard :onboardingLoaded="${x => x.onboardingAttached}"
    @onboarding-cancel="${x => x.closeOnboarding()}"
    @onboarding-submit="${x => x.closeOnboarding()}"></tutorial-onboarding-wizard>
`, (0, fast_element_1.html) `
<div class="tutorial-form-page">
    <a class="editor-back" @click="${x => x.cancel()}">
        <i class="simple-icon-arrow-left"></i>
        ${() => 'tutorial.form.backToList'.t()}
    </a>

    <div class="editor-head">
        <div class="min-w-0">
            <h1>${x => x.tutorialId ? 'tutorial.form.editTitle'.t() : 'tutorial.form.createTitle'.t()}</h1>
            <p>${x => x.formSubtitle}</p>
        </div>
        <div class="editor-actions">
            ${(0, fast_element_1.when)(x => !x.tutorialId && x.formStarted && !x.showOnboarding, (0, fast_element_1.html) `
            <button type="button" class="btn btn-outline-brand btn-icon" @click="${x => x.openOnboarding()}">
                <i class="simple-icon-magic-wand"></i>
                ${() => 'tutorial.form.onboarding.button'.t()}
            </button>
            `)}
            <button type="button" class="btn btn-outline-brand btn-icon" @click="${x => x.addStep()}"
                :disabled="${x => x.saving || (!x.tutorialId && x.form.source === 'file' && !x.scanned)}">
                <i class="simple-icon-plus"></i>
                ${() => 'tutorial.form.addStep'.t()}
            </button>
            <button type="button" class="btn btn-outline-brand" @click="${x => x.cancel()}"
                :disabled="${x => x.saving}">
                ${() => 'common.cancel'.t()}
            </button>
            ${(0, fast_element_1.when)(x => x.form.draft === true, (0, fast_element_1.html) `
            <part-switch name="publish" label="${() => 'tutorial.form.publish'.t()}" :value="${x => x.publish}"
                :onChange="${x => x.handlePublishChange.bind(x)}"></part-switch>
            `)}
            <button type="submit" class="btn btn-brand btn-icon" @click="${(x, c) => x.sendSubmit(x, c)}"
                :disabled="${x => x.saving || (!x.tutorialId && x.form.source === 'file' && !x.scanned)}">
                <i class="simple-icon-check"></i>
                ${x => x.saving ? 'crud.saving'.t() : (x.tutorialId ? 'common.update'.t() : 'common.create'.t())}
            </button>
        </div>
    </div>
    ${(0, fast_element_1.when)(x => !x.tutorialId && !x.formStarted, (0, fast_element_1.html) `
    <rws-modal noborderHeader="true" :header="${() => 'tutorial.form.start.title'.t()}" centerTop="true"
        maxWidth="900px" :closeModal="${x => x.cancel.bind(x)}">
        <div slot="closeButton"><button class="modal-button"><i class="simple-icon-close"></i></button></div>
        <div class="modal-body start-choice-modal">
            <div class="nt-paths">
                <div class="nt-col">
                    <button type="button" class="nt-path is-ai" @click="${x => x.openOnboarding()}">
                        <span class="nt-icon"><i class="simple-icon-magic-wand"></i></span>
                        <strong>${() => 'tutorial.form.start.onboarding.title'.t()}</strong>
                        <small>${() => 'tutorial.form.start.onboarding.description'.t()}</small>
                        <span class="nt-go">${() => 'tutorial.form.start.onboarding.action'.t()} <i
                                class="simple-icon-arrow-right"></i></span>
                    </button>
                    <section class="nt-how">
                        <h6><i class="simple-icon-info"></i> ${() => 'tutorial.form.start.how.title'.t()}</h6>
                        <ol>
                            <li><span class="nt-step">1</span>
                                <div class="nt-step-copy"><strong>${() => 'tutorial.form.start.how.step1.title'.t()}</strong><span>${() => 'tutorial.form.start.how.step1'.t()}</span></div>
                            </li>
                            <li><span class="nt-step">2</span>
                                <div class="nt-step-copy"><strong>${() => 'tutorial.form.start.how.step2.title'.t()}</strong><span>${() => 'tutorial.form.start.how.step2'.t()}</span></div>
                            </li>
                            <li><span class="nt-step">3</span>
                                <div class="nt-step-copy"><strong>${() => 'tutorial.form.start.how.step3.title'.t()}</strong><span>${() => 'tutorial.form.start.how.step3'.t()}</span></div>
                            </li>
                        </ol>
                    </section>
                </div>
                <div class="nt-col">
                    <button type="button" class="nt-path" @click="${x => x.startForm()}">
                        <span class="nt-icon"><i class="simple-icon-pencil"></i></span>
                        <strong>${() => 'tutorial.form.start.form.title'.t()}</strong>
                        <small>${() => 'tutorial.form.start.form.description'.t()}</small>
                        <span class="nt-go">${() => 'tutorial.form.start.form.action'.t()} <i
                                class="simple-icon-arrow-right"></i></span>
                    </button>
                    <section class="nt-how">
                        <h6><i class="simple-icon-info"></i> ${() => 'tutorial.form.start.form.how.title'.t()}</h6>
                        <ol>
                            <li><span class="nt-step">1</span>
                                <div class="nt-step-copy"><strong>${() => 'tutorial.form.start.form.how.step1.title'.t()}</strong><span>${() => 'tutorial.form.start.form.how.step1'.t()}</span></div>
                            </li>
                            <li><span class="nt-step">2</span>
                                <div class="nt-step-copy"><strong>${() => 'tutorial.form.start.form.how.step2.title'.t()}</strong><span>${() => 'tutorial.form.start.form.how.step2'.t()}</span></div>
                            </li>
                            <li><span class="nt-step">3</span>
                                <div class="nt-step-copy"><strong>${() => 'tutorial.form.start.form.how.step3.title'.t()}</strong><span>${() => 'tutorial.form.start.form.how.step3'.t()}</span></div>
                            </li>
                            <li><span class="nt-step">4</span>
                                <div class="nt-step-copy"><strong>${() => 'tutorial.form.start.form.how.step4.title'.t()}</strong><span>${() => 'tutorial.form.start.form.how.step4'.t()}</span></div>
                            </li>
                        </ol>
                    </section>
                </div>
            </div>
        </div>
    </rws-modal>
    `, (0, fast_element_1.html) `
    ${(0, fast_element_1.when)(x => x.loading || x.saving, (0, fast_element_1.html) `
    <div class="scan-overlay">
        <app-loader></app-loader>
        ${(0, fast_element_1.when)(x => x.scanProgressPhase !== '', (0, fast_element_1.html) `
        <div class="scan-progress">
            ${x => `tutorial.form.scanProgress.${x.scanProgressPhase}`.t()}
            ${(0, fast_element_1.when)(x => x.scanProgressTotalSections > 0 && x.scanProgressPhase === 'content', (0, fast_element_1.html) `
            · ${() => 'tutorial.form.scanProgress.section'.t()} ${x => x.scanProgressCurrentSection}/${x => x.scanProgressTotalSections}
            `)}
        </div>
        `)}
    </div>
    `)}

    <the-form :onSubmit="${x => x.handleSubmit.bind(x)}" style="${x => x.showOnboarding ? 'display:none' : ''}">
        <div class="tutorial-form" ?loading="${x => x.loading}">
            <div
                class="${x => 'tutorial-form-editor' + (!x.tutorialId && x.form.source === 'file' && !x.scanned ? ' scan-pending' : '')}">
                <div class="tutorial-form-carousel">
                    <div class="tutorial-form-carousel-track"
                        style="${x => 'transform: translateX(-' + (x.currentStepIndex * 100) + '%)'}">
                        <div class="tutorial-form-slide slide-info" ?active="${x => x.currentStepIndex === 0}"
                            ?inert="${x => x.currentStepIndex !== 0}">
                            <div class="row g-4">
                                <div class="col-lg-6">
                                    <section class="editor-card h-100">
                                        <div class="editor-card-title">
                                            <h3>${() => 'tutorial.form.source'.t()}</h3>
                                        </div>
                                        <part-radio class="form-part source-radio" label="tutorial.form.source.label"
                                            name="source" :value="${x => x.form.source}"
                                            :options="${x => x.sourceOptions}"></part-radio>

                                        <part-select name="avatarId" required="true"
                                            label="${() => 'tutorial.form.avatar'.t()}"
                                            :value="${x => { var _a, _b; return ((_b = (_a = x.form.avatar) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString()) || ''; }}" :options="${x => [
    { value: '', label: 'tutorial.form.selectAvatar'.t() },
    ...x.availableAvatars.map(avatar => {
        var _a;
        return ({
            value: ((_a = avatar.id) === null || _a === void 0 ? void 0 : _a.toString()) || '',
            label: avatar.name
        });
    })
]}"></part-select>

                                        <part-file-upload name="sourceFile"
                                            label="${() => 'tutorial.form.sourceFile.label'.t()}"
                                            placeholder="${() => 'tutorial.form.sourceFile.placeholder'.t()}"
                                            :value="${x => x.form.sourceFile}"
                                            :onSelectFile="${x => x.onSourceFileUpload.bind(x)}"></part-file-upload>

                                        <part-select name="scanKnowledgeId"
                                            label="${() => 'tutorial.form.scanKnowledge.label'.t()}"
                                            :value="${x => x.form.scanKnowledgeId || ''}" :options="${x => [
    { value: '', label: 'tutorial.form.scanKnowledge.none'.t() },
    ...x.knowledgeOptions
]}"></part-select>

                                        <div class="fl-group">
                                            <div class="fl-group-label">${() => 'tutorial.form.scanPages.label'.t()}
                                            </div>
                                            <div class="page-range">
                                                <part-input type="number" class="no-margin small" name="scanPagesFrom"
                                                    :value="${x => { var _a; return (_a = x.form.scanPagesFrom) !== null && _a !== void 0 ? _a : ''; }}"></part-input>
                                                <span>–</span>
                                                <part-input type="number" class="no-margin small" name="scanPagesTo"
                                                    :value="${x => { var _a; return (_a = x.form.scanPagesTo) !== null && _a !== void 0 ? _a : ''; }}"></part-input>
                                            </div>
                                        </div>

                                        <part-textarea name="tutorialGoal"
                                            label="${() => 'tutorial.form.tutorialGoal'.t()}"
                                            :value="${x => x.form.tutorialGoal}"
                                            placeholder="${() => 'tutorial.form.tutorialGoalPlaceholder'.t()}"
                                            rows="3"></part-textarea>

                                        <div class="scan-box">
                                            ${(0, fast_element_1.when)(x => x.tutorialId && x.form.source === 'file' && x.form.sourceFile, (0, fast_element_1.html) `
                                            <button type="button" class="btn btn-outline-brand btn-scan"
                                                @click="${x => x.regenerateFromPdf.bind(x)()}"
                                                :disabled="${x => x.loading || x.saving}">
                                                <i class="simple-icon-reload"></i>
                                                ${() => 'tutorial.form.regenerateFromPdf'.t()}
                                            </button>
                                            `, (0, fast_element_1.html) `
                                            <button type="button" class="btn btn-outline-brand btn-scan"
                                                @click="${x => x.scanSourceFile.bind(x)()}">
                                                <i class="simple-icon-magnifier"></i>
                                                ${() => 'tutorial.form.scanSourceFile'.t()}
                                            </button>
                                            `)}
                                            <small class="scan-description">
                                                ${x => x.form.source === 'file' ?
    'tutorial.form.scanSourceFile.description.file'.t() :
    'tutorial.form.scanSourceFileDescription'.t()}
                                            </small>
                                        </div>
                                    </section>
                                </div>

                                <div class="col-lg-6">
                                    <section class="editor-card h-100"
                                        style="${x => !x.tutorialId && x.form.source === 'file' && !x.scanned ? 'display:none' : ''}">
                                        <div class="editor-card-title">
                                            <h3>${() => 'tutorial.form.basicInfo'.t()}</h3>
                                            <part-checkbox name="active" label="${() => 'tutorial.form.active'.t()}"
                                                :checked="${x => x.form.active}"></part-checkbox>
                                        </div>

                                        <part-input name="name" label="${() => 'tutorial.form.name'.t()}"
                                            :value="${x => x.form.name}"
                                            placeholder="${() => 'tutorial.form.namePlaceholder'.t()}"
                                            required="true"></part-input>

                                        <part-textarea name="description"
                                            label="${() => 'tutorial.form.description'.t()}"
                                            :value="${x => x.form.description}"
                                            placeholder="${() => 'tutorial.form.descriptionPlaceholder'.t()}"
                                            rows="3"></part-textarea>

                                        <part-select name="categoryId" label="${() => 'tutorial.form.category'.t()}"
                                            :value="${x => { var _a; return ((_a = x.form.categoryId) === null || _a === void 0 ? void 0 : _a.toString()) || ''; }}"
                                            :options="${x => x.categoryOptions}"></part-select>

                                        <div class="row g-3">
                                            <div class="col-sm-7">
                                                <part-date name="expireAt" label="${() => 'tutorial.form.expireAt'.t()}"
                                                    :value="${x => x.form.expireAt || ''}"></part-date>
                                            </div>
                                            <div class="col-sm-5">
                                                <part-input type="number" name="hours"
                                                    label="${() => 'tutorial.form.hours'.t()}"
                                                    :value="${x => { var _a; return (_a = x.form.hours) !== null && _a !== void 0 ? _a : ''; }}" min="0" step="0.5"></part-input>
                                            </div>
                                        </div>

                                        <part-textarea name="introText" label="${() => 'tutorial.form.introText'.t()}"
                                            :value="${x => x.form.introText}"
                                            placeholder="${() => 'tutorial.form.introTextPlaceholder'.t()}"
                                            rows="4"></part-textarea>

                                        <div class="fl-group mb-0">
                                            <div class="fl-group-label">${() => 'tutorial.form.logo'.t()}</div>
                                            <part-file-upload name="logo" :value="${x => x.form.logo}" accept="image/*"
                                                placeholder="${() => 'tutorial.form.logo'.t()}"
                                                :onSelectFile="${x => x.onLogoUpload.bind(x)}"></part-file-upload>
                                        </div>
                                        ${(0, fast_element_1.when)(x => x.form.logo, (0, fast_element_1.html) `
                                        <div class="tutorial-logo-preview mt-3">
                                            <img src="${x => !x.tutorialId ? `data:${x.form.logo.mimeType};base64,${x.form.logo.path}` : `/uploads/${x.form.logo.filename}`}"
                                                alt="Tutorial Logo" class="img-fluid rounded" />
                                        </div>
                                        `)}
                                    </section>
                                </div>

                                <div class="col-12 mt-4">
                                    <section class="editor-card">
                                        <div class="editor-card-title">
                                            <h3>${() => 'tutorial.form.steps'.t()} <span class="count">${x => x.steps.length}</span></h3>
                                        </div>
                                        ${(0, fast_element_1.repeat)(x => x.steps, (0, fast_element_1.html) `
                                        <button type="button" class="overview-step"
                                            @click="${(step, c) => c.parent.goToStep(c.index + 1)}">
                                            <span class="sp-num">${(step, c) => c.index + 1}</span>
                                            <span class="sp-text">
                                                <strong>${step => step.title || ''}</strong>
                                                <small>${(step, c) => c.parent.sectionCountLabel(step)}</small>
                                            </span>
                                            <i class="simple-icon-arrow-right"></i>
                                        </button>
                                        `, { positioning: true })}
                                        ${(0, fast_element_1.when)(x => x.steps.length === 0, (0, fast_element_1.html) `
                                        <p class="overview-empty">${() => 'tutorial.form.noSteps'.t()}</p>
                                        `)}
                                    </section>
                                </div>
                            </div>
                        </div>

                        ${(0, fast_element_1.repeat)(x => x.steps, (0, fast_element_1.html) `
                        <div class="tutorial-form-slide slide-step"
                            ?active="${(step, c) => c.parent.currentStepIndex === c.index + 1}"
                            ?inert="${(step, c) => c.parent.currentStepIndex !== c.index + 1}">
                            <section class="editor-card" data-step="${(step, c) => c.index}">
                                <div class="editor-card-head">
                                    <span class="step-pill">${(step, c) => c.index + 1}</span>
                                    <div class="flex-grow-1 min-w-0 step-title-part">
                                        <part-input class="no-margin" label="${() => 'tutorial.form.stepName'.t()}"
                                            name="${(step, c) => `step-title-${c.index}`}"
                                            :value="${step => step.title}"
                                            placeholder="${() => 'tutorial.form.stepNamePlaceholder'.t()}"
                                            required="true"></part-input>
                                    </div>
                                    <div class="tool-group">
                                        <button type="button" class="btn btn-tool"
                                            @click="${(step, c) => c.parent.moveStepUp(c.index)}"
                                            ?disabled="${(step, c) => c.index === 0}"
                                            title="${() => 'common.moveUp'.t()}">
                                            <i class="simple-icon-arrow-up"></i>
                                        </button>
                                        <button type="button" class="btn btn-tool"
                                            @click="${(step, c) => c.parent.moveStepDown(c.index)}"
                                            ?disabled="${(step, c) => c.index === c.parent.steps.length - 1}"
                                            title="${() => 'common.moveDown'.t()}">
                                            <i class="simple-icon-arrow-down"></i>
                                        </button>
                                        <button type="button" class="btn btn-tool is-danger"
                                            @click="${(step, c) => c.parent.removeStep(c.index)}"
                                            ?disabled="${(step, c) => c.parent.steps.length <= 1}"
                                            title="${() => 'common.delete'.t()}">
                                            <i class="simple-icon-trash"></i>
                                        </button>
                                    </div>
                                </div>

                                <div class="section-list">
                                    ${(0, fast_element_1.repeat)((step, stepContext) => stepContext.parent.getSectionsForStep(stepContext.index), (0, fast_element_1.html) `
                                    <article class="section-edit"
                                        data-section-index="${(section, sectionContext) => sectionContext.index}">
                                        <div class="section-edit-head">
                                            <span class="sec-num">${(section, sectionContext) => sectionContext.index +
    1}</span>
                                            <div class="section-title-part flex-grow-1 min-w-0">
                                                <part-input class="mt-3"
                                                    label="${() => 'tutorial.form.sectionName'.t()}"
                                                    name="${(section, sectionContext) => `section-title-${sectionContext.parentContext.index}-${sectionContext.index}`}"
                                                    :value="${section => section.title}"
                                                    placeholder="${() => 'tutorial.form.sectionNamePlaceholder'.t()}"
                                                    required="true"></part-input>
                                            </div>
                                            <div class="tool-group">
                                                <button type="button" class="btn btn-tool"
                                                    @click="${(section, sectionContext) => sectionContext.parentContext.parent.moveSectionUp(sectionContext.parentContext.index, sectionContext.index)}"
                                                    ?disabled="${(section, sectionContext) => sectionContext.index === 0}"
                                                    title="${() => 'common.moveUp'.t()}">
                                                    <i class="simple-icon-arrow-up"></i>
                                                </button>
                                                <button type="button" class="btn btn-tool"
                                                    @click="${(section, sectionContext) => sectionContext.parentContext.parent.moveSectionDown(sectionContext.parentContext.index, sectionContext.index)}"
                                                    ?disabled="${(section, sectionContext) => sectionContext.index === sectionContext.parentContext.parent.getSectionsForStep(sectionContext.parentContext.index).length - 1}"
                                                    title="${() => 'common.moveDown'.t()}">
                                                    <i class="simple-icon-arrow-down"></i>
                                                </button>
                                                <button type="button" class="btn btn-tool is-danger"
                                                    @click="${(section, sectionContext) => sectionContext.parentContext.parent.removeSectionFromStep(sectionContext.parentContext.index, sectionContext.index)}"
                                                    ?disabled="${(section, sectionContext) => sectionContext.parentContext.parent.getSectionsForStep(sectionContext.parentContext.index).length <= 1}"
                                                    title="${() => 'common.delete'.t()}">
                                                    <i class="simple-icon-trash"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="section-edit-body">
                                            <part-textarea label="${() => 'tutorial.form.sectionIntro'.t()}"
                                                name="${(section, sectionContext) => `section-description-${sectionContext.parentContext.index}-${sectionContext.index}`}"
                                                :value="${section => section.description || ''}"
                                                placeholder="${() => 'tutorial.form.sectionIntroPlaceholder'.t()}"
                                                rows="5"></part-textarea>

                                            ${(0, fast_element_1.when)((section, c) => c.parentContext.parent.form.source === 'ai', (0, fast_element_1.html) `
                                            <div class="sub-block">
                                                <div class="sub-block-head">
                                                    <span><i class="simple-icon-pencil"></i> ${() => 'tutorial.form.sectionPrompt'.t()}</span>
                                                </div>
                                                <part-textarea
                                                    name="${(section, sectionContext) => `section-prompt-${sectionContext.parentContext.index}-${sectionContext.index}`}"
                                                    :value="${section => section.prompt || ''}"
                                                    placeholder="${() => 'tutorial.form.sectionPromptPlaceholder'.t()}"
                                                    rows="5"></part-textarea>
                                            </div>
                                            `)}

                                            ${(0, fast_element_1.when)((section, c) => c.parentContext.parent.form.source === 'file', (0, fast_element_1.html) `
                                            <div class="sub-block">
                                                <div class="sub-block-head">
                                                    <span><i class="simple-icon-pencil"></i> ${() => 'tutorial.form.sectionContent'.t()}</span>
                                                </div>
                                                <part-richtextarea :value="${x => x.sourceText}"
                                                    name="${(section, sectionContext) => `section-sourceText-${sectionContext.parentContext.index}-${sectionContext.index}`}"></part-richtextarea>
                                            </div>
                                            `)}

                                            <div class="sub-block">
                                                <div class="sub-block-head">
                                                    <span><i class="simple-icon-check"></i> ${() => 'tutorial.form.tasks'.t()} <span class="count">${(section, sectionContext) => (section.todoItems ||
    []).length}</span></span>
                                                    <button type="button" class="btn btn-link-brand" @click="${(section, sectionContext) => {
    var _a;
    const stepIndex = sectionContext.parentContext.index;
    const sectionIndex = sectionContext.index;
    let parent = sectionContext.parentContext.parent;
    if (!parent && ((_a = sectionContext.parentContext.parentContext) === null || _a === void 0 ? void 0 : _a.parent)) {
        parent = sectionContext.parentContext.parentContext.parent;
    }
    if (parent && typeof parent.addTodoItem === 'function') {
        parent.addTodoItem(stepIndex, sectionIndex);
    }
}}">
                                                        <i class="simple-icon-plus"></i> ${() => 'tutorial.form.addTask'.t()}
                                                    </button>
                                                </div>
                                                ${(0, fast_element_1.when)(section => (section.todoItems || []).length > 0, (0, fast_element_1.html) `
                                                <div class="task-list">
                                                    ${(0, fast_element_1.repeat)(section => section.todoItems || [], (0, fast_element_1.html) `
                                                    <div class="task-edit"
                                                        data-task="${(todoItem, todoContext) => todoContext.index}">
                                                        <part-input class="no-margin"
                                                            name="${(todoItem, todoContext) => `todo-title-${todoContext.parentContext.parentContext.index}-${todoContext.parentContext.index}-${todoContext.index}`}"
                                                            :value="${todoItem => todoItem.title || ''}"
                                                            placeholder="${() => 'tutorial.form.todoItemPlaceholder'.t()}"></part-input>
                                                        <part-input class="no-margin"
                                                            name="${(todoItem, todoContext) => `todo-desc-${todoContext.parentContext.parentContext.index}-${todoContext.parentContext.index}-${todoContext.index}`}"
                                                            :value="${todoItem => todoItem.description || ''}"
                                                            placeholder="${() => 'tutorial.form.todoItemDescriptionPlaceholder'.t()}"></part-input>
                                                        <button type="button" class="btn btn-tool is-danger" @click="${(todoItem, todoContext) => {
    var _a;
    const stepIndex = todoContext.parentContext.parentContext.index;
    const sectionIndex = todoContext.parentContext.index;
    const todoIndex = todoContext.index;
    let parent = todoContext.parentContext.parentContext.parent;
    if (!parent && ((_a = todoContext.parentContext.parentContext.parentContext) === null || _a === void 0 ? void 0 : _a.parent)) {
        parent = todoContext.parentContext.parentContext.parentContext.parent;
    }
    if (parent && typeof parent.removeTodoItem === 'function') {
        parent.removeTodoItem(stepIndex, sectionIndex, todoIndex);
    }
}}" title="${() => 'common.delete'.t()}">
                                                            <i class="simple-icon-trash"></i>
                                                        </button>
                                                    </div>
                                                    `, { positioning: true })}
                                                </div>
                                                `)}
                                            </div>

                                            <div class="sub-block">
                                                <div class="sub-block-head">
                                                    <span><i class="simple-icon-paper-clip"></i> ${() => 'tutorial.form.attachments'.t()} <span class="count">${(section, sectionContext) => sectionContext.parentContext.parent.attachmentsCount(section)}</span></span>
                                                    <button type="button" class="btn btn-link-brand mb-0"
                                                        @click="${(section, sectionContext) => sectionContext.parentContext.parent.openSectionFileModal(sectionContext.parentContext.index, sectionContext.index)}">
                                                        <i class="simple-icon-plus"></i> ${() => 'tutorial.form.addFile'.t()}
                                                    </button>
                                                </div>
                                                <div class="file-list">
                                                    ${(0, fast_element_1.when)(section => section.screenshot, (0, fast_element_1.html) `
                                                    <span class="file-chip">
                                                        <i class="simple-icon-picture"></i>
                                                        <span class="fc-name"
                                                            title="${section => section.screenshot.filename}">${section => section.screenshot.filename}</span>
                                                        <button type="button"
                                                            @click="${(section, sectionContext) => sectionContext.parentContext.parent.handleSectionFileChange(sectionContext.parentContext.index, sectionContext.index, 'screenshot', null)}"><i
                                                                class="simple-icon-close"></i></button>
                                                    </span>
                                                    `)}
                                                    ${(0, fast_element_1.when)(section => section.video, (0, fast_element_1.html) `
                                                    <span class="file-chip">
                                                        <i class="simple-icon-film"></i>
                                                        <span class="fc-name"
                                                            title="${section => section.video.filename}">${section => section.video.filename}</span>
                                                        <button type="button"
                                                            @click="${(section, sectionContext) => sectionContext.parentContext.parent.handleSectionFileChange(sectionContext.parentContext.index, sectionContext.index, 'video', null)}"><i
                                                                class="simple-icon-close"></i></button>
                                                    </span>
                                                    `)}
                                                    ${(0, fast_element_1.when)(section => section.screenshotMini, (0, fast_element_1.html) `
                                                    <span class="file-chip">
                                                        <i class="simple-icon-picture"></i>
                                                        <span class="fc-name"
                                                            title="${section => section.screenshotMini.filename}">${section => section.screenshotMini.filename}</span>
                                                        <button type="button"
                                                            @click="${(section, sectionContext) => sectionContext.parentContext.parent.handleSectionFileChange(sectionContext.parentContext.index, sectionContext.index, 'screenshotMini', null)}"><i
                                                                class="simple-icon-close"></i></button>
                                                    </span>
                                                    `)}
                                                    ${(0, fast_element_1.when)(section => section.videoMini, (0, fast_element_1.html) `
                                                    <span class="file-chip">
                                                        <i class="simple-icon-film"></i>
                                                        <span class="fc-name"
                                                            title="${section => section.videoMini.filename}">${section => section.videoMini.filename}</span>
                                                        <button type="button"
                                                            @click="${(section, sectionContext) => sectionContext.parentContext.parent.handleSectionFileChange(sectionContext.parentContext.index, sectionContext.index, 'videoMini', null)}"><i
                                                                class="simple-icon-close"></i></button>
                                                    </span>
                                                    `)}
                                                </div>
                                                ${(0, fast_element_1.when)(section => (section.tutorialSectionFiles || []).length > 0, (0, fast_element_1.html) `
                                                <div class="section-file-list">
                                                    ${(0, fast_element_1.repeat)((section, sectionContext) => section.tutorialSectionFiles
    || [], (0, fast_element_1.html) `
                                                    <div class="section-file-row">
                                                        <div class="section-file-cards">
                                                            <div class="section-file-card">
                                                                <p class="section-file-card-heading">
                                                                    <strong>${'tutorial.form.addFile'.t()}</strong>
                                                                </p>
                                                                <file-card-zoom
                                                                    :fileData="${sectionFile => sectionFile.file}"
                                                                    preview="true" showDownload="true">
                                                                </file-card-zoom>
                                                            </div>
                                                            ${(0, fast_element_1.when)(sectionFile => sectionFile.mini, (0, fast_element_1.html) `
                                                            <div class="section-file-card">
                                                                <p class="section-file-card-heading">
                                                                    <strong>${'tutorial.form.sectionFileMiniature'.t()}</strong>
                                                                </p>
                                                                <file-card-zoom
                                                                    :fileData="${sectionFile => sectionFile.mini}"
                                                                    preview="true" showDownload="true">
                                                                </file-card-zoom>
                                                            </div>
                                                            `)}
                                                        </div>
                                                        <div class="section-file-actions">
                                                            <button type="button" class="btn btn-tool"
                                                                title="${() => 'common.edit'.t()}" @click="${(sectionFile, fileContext) => fileContext.parentContext.parentContext.parent.openSectionFileModal(fileContext.parentContext.parentContext.index, fileContext.parentContext.index, fileContext.index)}">
                                                                <i class="simple-icon-pencil"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-tool is-danger"
                                                                title="${() => 'common.delete'.t()}" @click="${(sectionFile, fileContext) => fileContext.parentContext.parentContext.parent.removeSectionFile(fileContext.parentContext.parentContext.index, fileContext.parentContext.index, fileContext.index)}">
                                                                <i class="simple-icon-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    `, { positioning: true })}
                                                </div>
                                                `)}
                                            </div>

                                            ${(0, fast_element_1.when)((section, c) => c.parentContext.parent.form.source === 'ai', (0, fast_element_1.html) `
                                            <div class="sub-block">
                                                <div class="sub-block-head">
                                                    <span><i class="simple-icon-pencil"></i> ${() => 'tutorial.form.sectionPrompt'.t()}</span>
                                                </div>
                                                <part-textarea
                                                    name="${(section, sectionContext) => `section-prompt-${sectionContext.parentContext.index}-${sectionContext.index}`}"
                                                    :value="${section => section.prompt || ''}"
                                                    placeholder="${() => 'tutorial.form.sectionPromptPlaceholder'.t()}"
                                                    rows="5"></part-textarea>
                                            </div>
                                            `)}

                                            ${(0, fast_element_1.when)((section, c) => c.parentContext.parent.form.source === 'file', (0, fast_element_1.html) `
                                            <div class="sub-block">
                                                <div class="sub-block-head">
                                                    <span><i class="simple-icon-book-open"></i> ${() => 'tutorial.form.source_pages'.t()}</span>
                                                </div>
                                                <div class="page-range">
                                                    <part-input type="number" class="no-margin small"
                                                        name="${(section, sectionContext) => `section-sourceFrom-${sectionContext.parentContext.index}-${sectionContext.index}`}"
                                                        :value="${section => { var _a; return (_a = section.sourcePagesFrom) !== null && _a !== void 0 ? _a : ''; }}"></part-input>
                                                    <span>–</span>
                                                    <part-input type="number" class="no-margin small"
                                                        name="${(section, sectionContext) => `section-sourceTo-${sectionContext.parentContext.index}-${sectionContext.index}`}"
                                                        :value="${section => { var _a; return (_a = section.sourcePagesTo) !== null && _a !== void 0 ? _a : ''; }}"></part-input>
                                                </div>
                                            </div>
                                            `)}

                                            <button type="button" class="btn btn-outline-secondary btn-sm mt-2"
                                                @click="${(section, sectionContext) => sectionContext.parentContext.parent.openFormEditor(sectionContext.parentContext.index, sectionContext.index)}">
                                                <i class="simple-icon-pencil"></i>
                                                ${() => 'tutorial.form.editor.formEditor'.t()}
                                            </button>
                                        </div>
                                    </article>
                                    `, { positioning: true })}
                                </div>

                                <button type="button" class="btn add-dashed"
                                    @click="${(step, c) => c.parent.addSectionToStep(c.index)}">
                                    <i class="simple-icon-plus"></i> ${() => 'tutorial.form.addSection'.t()}
                                </button>
                            </section>
                        </div>
                        `, { positioning: true })}

                    </div>
                </div>

            </div>

        </div>
    </the-form>

    <div class="editor-nav">
        <div class="editor-nav-progress"><span style="${x => 'width: ' + x.progressPercent + '%'}"></span></div>
        <div class="container editor-nav-inner">
            <button type="button" class="btn nav-arrow" @click="${x => x.prevStep()}" :disabled="${x => !x.canGoPrev}">
                <i class="simple-icon-arrow-left"></i>
                <span class="d-none d-sm-inline">${() => 'tutorial.form.previous'.t()}</span>
            </button>

            <div class="picker-group">
                <tutorial-slide-nav :steps="${x => x.steps}" :currentStepIndex="${x => x.currentStepIndex}"
                    :basicInfoLabel="${() => 'tutorial.form.basicInfo'.t()}"
                    :sectionsLabel="${() => 'tutorial.form.sections'.t()}"
                    ?hidden="${x => !x.tutorialId && x.form.source === 'file' && !x.scanned}">
                </tutorial-slide-nav>

                <tutorial-slide-section-nav :sections="${x => x.currentStepSections}"
                    :stepIndex="${x => x.currentStepIndex}" :currentStepIndex="${x => x.currentStepIndex}"
                    ?hidden="${x => x.currentStepIndex === 0 || x.currentStepSections.length === 0 || (!x.tutorialId && x.form.source === 'file' && !x.scanned)}">
                </tutorial-slide-section-nav>
            </div>

            <button type="button" class="btn nav-arrow nav-arrow-next" @click="${x => x.nextStep()}"
                :disabled="${x => !x.canGoNext}">
                <span class="d-none d-sm-inline">${() => 'tutorial.form.next'.t()}</span>
                <i class="simple-icon-arrow-right"></i>
            </button>
        </div>
    </div>

    <div class="editor-foot-actions">
        <div class="efa-hint">
            ${x => {
    var _a;
    return x.currentStepIndex === 0
        ? 'tutorial.form.basicInfo'.t()
        : 'tutorial.form.step'.t() + ' ' + x.currentStepIndex + ' / ' + x.steps.length + ' · ' +
            (((_a = x.steps[x.currentStepIndex - 1]) === null || _a === void 0 ? void 0 : _a.title) || '');
}}
        </div>
        <div class="editor-actions">
            <button type="button" class="btn btn-outline-brand btn-icon" @click="${x => x.addStep()}"
                :disabled="${x => x.saving || (!x.tutorialId && x.form.source === 'file' && !x.scanned)}">
                <i class="simple-icon-plus"></i>
                ${() => 'tutorial.form.addStep'.t()}
            </button>
            <button type="button" class="btn btn-outline-brand" @click="${x => x.cancel()}"
                :disabled="${x => x.saving}">
                ${() => 'common.cancel'.t()}
            </button>
            ${(0, fast_element_1.when)(x => x.form.draft === true, (0, fast_element_1.html) `
            <part-switch name="publish" label="${() => 'tutorial.form.publish'.t()}" :value="${x => x.publish}"
                :onChange="${x => x.handlePublishChange.bind(x)}"></part-switch>
            `)}
            <button type="submit" class="btn btn-brand btn-icon" @click="${(x, c) => x.sendSubmit(x, c)}"
                :disabled="${x => x.saving || (!x.tutorialId && x.form.source === 'file' && !x.scanned)}">
                <i class="simple-icon-check"></i>
                ${x => x.saving ? 'crud.saving'.t() : (x.tutorialId ? 'common.update'.t() : 'common.create'.t())}
            </button>
        </div>
    </div>

    <div class="${x => 'editor-toast' + (x.toastMessage ? (x.toastError ? ' is-error show' : ' show') : '')}">
        <i class="${x => 'simple-icon-' + (x.toastError ? 'exclamation' : 'check')}"></i>
        ${x => x.toastMessage}
    </div>
    `)}
</div>
`)}

${(0, fast_element_1.when)(x => x.selectedModel && !x.showOnboarding && (x.tutorialId || x.formStarted), (0, fast_element_1.html) `<div
    class="tutorial_chat_widget${x => x.chatDrawerOpen ? ' open' : ''}">
    <div class="drawer-toggler">
        <button @click="${x => x.toggleChatDrawer.bind(x)()}">
            ${'tutorial.form.assistant'.t()}
        </button>
    </div>
    <div class="drawer-chat">
        ${(0, fast_element_1.when)(x => !x.chatStarted, (0, fast_element_1.html) `
        <div class="example-prompts">
            <p @click="${x => x.runExamplePrompt('tutorial.form.examplePrompts_1'.t())}">
                ${'tutorial.form.examplePrompts_1'.t()}</p>
            <p @click="${x => x.runExamplePrompt('tutorial.form.examplePrompts_2'.t())}">
                ${'tutorial.form.examplePrompts_2'.t()}</p>
            <p @click="${x => x.runExamplePrompt('tutorial.form.examplePrompts_3'.t())}">
                ${'tutorial.form.examplePrompts_3'.t()}</p>
        </div>
        `)}
        <app-chat mini="true" compact="true" ${(0, fast_element_1.ref)('chatComponent')}
            injectCss="${x => x.webflex ? '/assets/css/chat-override-flex.css' : ''}"
            :selectedModel="${x => x.selectedModel}" :selectedAIProvider="openrouter">
        </app-chat>
    </div>
</div>`)}

${(0, fast_element_1.when)(x => x.formEditorOpen, (0, fast_element_1.html) `
<rws-modal :header="${() => 'tutorial.form.editor.formEditor'.t()}" :centerTop="${false}"
    :closeModal="${x => x.onFormEditorClose.bind(x)}">
    <div class="form-edit-modal-content">
        <div class="modal-body">
            <div class="container-fluid">
                <ai-form-editor :data="${x => x.editingSectionFormData}"
                    @ai-form-editor:changed="${(x, c) => x.handleFormEditorChanged(c.event)}"
                    @ai-form-editor:save="${(x, c) => x.handleFormEditorSave(c.event)}"></ai-form-editor>
            </div>
        </div>
    </div>
</rws-modal>
`)}

${(0, fast_element_1.when)(x => x.sectionFileModalOpen, (0, fast_element_1.html) `
<rws-modal :header="${() => 'tutorial.form.addFile'.t()}" :centerTop="${false}"
    :closeModal="${x => x.closeSectionFileModal.bind(x)}">
    <div class="section-file-modal-content">
        <div class="modal-body">
            <part-file-upload ignored="true" mode="base64" name="tutorialSectionFile"
                label="${() => 'tutorial.form.addFile'.t()}" :value="${x => { var _a; return ((_a = x.pendingSectionFile) === null || _a === void 0 ? void 0 : _a.file) || null; }}"
                :onSelectFile="${x => x.handleSectionFileUpload.bind(x)}">
            </part-file-upload>
            <part-file-upload ignored="true" mode="base64" name="tutorialSectionFileMini"
                label="${() => 'tutorial.form.sectionFileMiniature'.t()}" accept="image/*"
                :value="${x => { var _a; return ((_a = x.pendingSectionFile) === null || _a === void 0 ? void 0 : _a.mini) || null; }}"
                :onSelectFile="${x => x.handleSectionFileMiniUpload.bind(x)}">
            </part-file-upload>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-brand" @click="${x => x.closeSectionFileModal()}">
                ${() => 'common.cancel'.t()}
            </button>
            <button type="button" class="btn btn-brand" @click="${x => x.saveSectionFile()}">
                ${() => 'common.save'.t()}
            </button>
        </div>
    </div>
</rws-modal>
`)}`;
require("./styles/layout.scss");
const styles = T.css `.tutorial-form-page {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 24px 24px 180px;
  max-width: 1200px;
  margin: 0 auto;
}
.tutorial-form-page .page-header {
  margin-bottom: 24px;
}
.tutorial-form-page .page-header h1 {
  margin: 0;
  color: var(--color-text-primary);
}
.tutorial-form-page .scan-description {
  display: block;
  margin-top: 6px;
  font-size: 0.75rem;
  line-height: 1.3;
  color: var(--color-text-secondary, #8f8f8f);
}
.tutorial-form-page .start-choice-modal {
  padding: 8px 4px 4px;
}
.tutorial-form-page .start-choice-modal .nt-paths {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.tutorial-form-page .start-choice-modal .nt-col {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 12px;
}
.tutorial-form-page .start-choice-modal .nt-path {
  position: relative;
  display: flex;
  min-width: 0;
  height: 260px;
  min-height: 260px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 20px 18px;
  box-sizing: border-box;
  border: 1.5px solid var(--brand-border);
  border-radius: 14px;
  background: #fff;
  color: var(--ink);
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}
.tutorial-form-page .start-choice-modal .nt-path:hover, .tutorial-form-page .start-choice-modal .nt-path:focus-visible {
  border-color: var(--brand);
  box-shadow: 0 14px 30px -18px rgba(31, 44, 85, 0.4);
  color: var(--ink);
  outline: none;
  transform: translateY(-2px);
}
.tutorial-form-page .start-choice-modal .nt-path.is-ai {
  background: linear-gradient(180deg, var(--brand-soft), #fff 65%);
}
.tutorial-form-page .start-choice-modal .nt-path strong {
  display: flex;
  height: 2.6em;
  flex: 0 0 2.6em;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  font-weight: 800;
}
.tutorial-form-page .start-choice-modal .nt-path small {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  color: var(--muted);
  font-size: 0.85rem;
  line-height: 1.5;
}
.tutorial-form-page .start-choice-modal .nt-path .nt-go {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: auto;
  padding-top: 6px;
  color: var(--brand-dark);
  font-size: 0.84rem;
  font-weight: 700;
}
.tutorial-form-page .start-choice-modal .nt-path .nt-go i {
  transition: transform 0.15s ease;
}
.tutorial-form-page .start-choice-modal .nt-path:hover .nt-go i, .tutorial-form-page .start-choice-modal .nt-path:focus-visible .nt-go i {
  transform: translateX(3px);
}
.tutorial-form-page .start-choice-modal .nt-icon {
  display: grid;
  width: 52px;
  height: 52px;
  flex-shrink: 0;
  place-items: center;
  margin-bottom: 4px;
  border: 1px solid var(--brand-border);
  border-radius: 50%;
  background: #fff;
  color: var(--brand);
  font-size: 1.35rem;
}
.tutorial-form-page .start-choice-modal .nt-how {
  flex: 1;
  padding: 14px 16px;
  border-radius: 12px;
  background: var(--bg);
}
.tutorial-form-page .start-choice-modal .nt-how h6 {
  margin-bottom: 12px;
  font-weight: 800;
}
.tutorial-form-page .start-choice-modal .nt-how h6 i {
  color: var(--brand);
}
.tutorial-form-page .start-choice-modal .nt-how ol {
  display: grid;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.tutorial-form-page .start-choice-modal .nt-how li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.tutorial-form-page .start-choice-modal .nt-how .nt-step-copy {
  display: block;
  min-width: 0;
  flex: 1;
}
.tutorial-form-page .start-choice-modal .nt-how .nt-step-copy strong {
  display: block;
  color: var(--ink);
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.3;
}
.tutorial-form-page .start-choice-modal .nt-how .nt-step-copy span {
  display: block;
  margin-top: 2px;
  color: var(--muted);
  font-size: 0.84rem;
  line-height: 1.5;
}
.tutorial-form-page .start-choice-modal .nt-step {
  display: grid;
  width: 26px;
  height: 26px;
  flex: 0 0 26px;
  place-items: center;
  border-radius: 50%;
  background: var(--brand);
  color: #fff;
  font-size: 0.8rem;
  font-weight: 800;
}
@media (max-width: 700px) {
  .tutorial-form-page .start-choice-modal .nt-paths {
    grid-template-columns: 1fr;
  }
}
.tutorial-form-page .tutorial-form[loading] {
  opacity: 0.6;
  pointer-events: none;
}
.tutorial-form-page .scan-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  pointer-events: none;
}
.tutorial-form-page .scan-overlay app-loader {
  z-index: 1001;
}
.tutorial-form-page .scan-overlay .scan-progress {
  position: absolute;
  top: calc(50% + 50px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1001;
  padding: 6px 14px;
  border-radius: 6px;
  background: var(--color-surface, #fff);
  color: var(--color-text-primary, #222);
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  text-align: center;
}
.tutorial-form-page .scan-overlay .scan-progress .scan-progress-section {
  margin-top: 2px;
  max-width: 480px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.85em;
  font-weight: 400;
}
.tutorial-form-page .form-section {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
}
.tutorial-form-page .form-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.tutorial-form-page .form-section .section-header h3 {
  margin: 0;
  color: var(--color-text-primary);
  font-size: 18px;
  font-weight: 600;
}
.tutorial-form-page .form-section .section-header .form-check {
  position: relative;
  padding: 0;
  margin: 0;
}
.tutorial-form-page .form-section .section-header .form-check input {
  position: absolute;
  left: 10px;
  top: 12px;
  margin: 0;
}
.tutorial-form-page .form-section .section-header .form-check label {
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  cursor: pointer;
  padding: 0 30px;
  min-width: 120px;
  line-height: 34px;
  transition: all 0.2s ease;
}
.tutorial-form-page .form-section .section-header .form-check label:hover {
  background: var(--color-background-hover);
}
.tutorial-form-page .form-section .section-header .form-check input:checked + label {
  background: #e3fde1 !important;
  border: 1px solid green;
}
.tutorial-form-page .form-section .form-description {
  margin: 0 0 16px 0;
  color: var(--color-text-secondary);
  font-size: 14px;
}
.tutorial-form-page .basic-info .basic-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 16px;
}
.tutorial-form-page .basic-info .basic-info-grid .left-column,
.tutorial-form-page .basic-info .basic-info-grid .right-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.tutorial-form-page .basic-info .basic-info-grid .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 768px) {
  .tutorial-form-page .basic-info .basic-info-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .tutorial-form-page .basic-info .basic-info-grid .form-row {
    grid-template-columns: 1fr;
  }
}
.tutorial-form-page .steps-section .add-step-btn {
  white-space: nowrap;
}
.tutorial-form-page .steps-section .steps-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.tutorial-form-page .steps-section .steps-list .step-container {
  background: var(--color-background-subtle);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 24px;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--color-border-light);
}
.tutorial-form-page .steps-section .steps-list .step-container .step-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary);
}
.tutorial-form-page .steps-section .steps-list .step-container .step-header .step-controls {
  display: flex;
  gap: 4px;
  align-items: center;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-header .remove-step-btn {
  background: none;
  border: none;
  color: var(--color-danger);
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-header .remove-step-btn:hover {
  background: var(--color-danger);
  color: white;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container {
  margin-top: 20px;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container .sections-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container .sections-header h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-primary);
}
.tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container .sections-header .add-section-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container .section-item {
  background: var(--color-surface);
  border: 1px solid var(--color-border-light);
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 16px;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container .section-item .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container .section-item .section-header h6 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}
.tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container .section-item .section-header .section-controls {
  display: flex;
  gap: 4px;
  align-items: center;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container .section-item .section-header .btn i {
  margin-right: 4px;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container .section-item .section-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container .section-item .section-form .file-uploads {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 768px) {
  .tutorial-form-page .steps-section .steps-list .step-container .step-form .sections-container .section-item .section-form .file-uploads {
    grid-template-columns: 1fr;
  }
}
.tutorial-form-page .form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 0;
  border-top: 1px solid var(--color-border);
  margin-top: 24px;
}
.tutorial-form-page input:not(:placeholder-shown) {
  background: #e3fde1;
  border: 1px solid green;
}
.tutorial-form-page .loading {
  text-align: center;
  padding: 20px;
  color: var(--color-text-muted);
}
.tutorial-form-page .todo-item-row {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 8px;
}
.tutorial-form-page .todo-item-row .todo-input-wrapper {
  flex: 1;
}
.tutorial-form-page .todo-item-row .btn-danger {
  height: 38px;
  width: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 8px;
}
.tutorial-form-page .todo-item-row .btn-danger i {
  font-size: 12px;
}
.tutorial-form-page .todo-item-row part-input {
  margin-bottom: 0;
}
.tutorial-form-page .tutorial-form-editor {
  display: block;
}
.tutorial-form-page .tutorial-form-carousel {
  min-width: 0;
  overflow: hidden;
}
.tutorial-form-page .editor-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 22px;
}
.tutorial-form-page .editor-card-title h3 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
}
.tutorial-form-page .active-check {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 0;
  cursor: pointer;
  margin: 0;
}
.tutorial-form-page .active-check .form-check-input {
  float: none;
  margin: 0;
}
.tutorial-form-page .active-check .form-check-label {
  font-size: 0.95rem;
}
.tutorial-form-page .src-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 22px;
}
.tutorial-form-page .src-option {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 10px;
  border: 1px solid transparent;
  border-radius: 10px;
  cursor: pointer;
}
.tutorial-form-page .src-option:hover {
  background: var(--bg);
}
.tutorial-form-page .src-option:has(input:checked) {
  background: var(--brand-soft);
  border-color: rgba(23, 180, 166, 0.35);
}
.tutorial-form-page .src-option .form-check-input {
  flex-shrink: 0;
  margin-top: 3px;
}
.tutorial-form-page .src-option strong {
  display: block;
  font-weight: 500;
  font-size: 0.98rem;
}
.tutorial-form-page .src-option small {
  display: block;
  color: var(--muted);
  font-size: 0.8rem;
  line-height: 1.35;
}
.tutorial-form-page .fl {
  position: relative;
  margin-bottom: 20px;
}
.tutorial-form-page .fl-label {
  position: absolute;
  top: -0.6em;
  left: 10px;
  z-index: 2;
  max-width: calc(100% - 20px);
  padding: 0 5px;
  background: #fff;
  color: var(--muted);
  font-size: 0.78rem;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
}
.tutorial-form-page .fl > .form-control,
.tutorial-form-page .fl > .form-select {
  padding-top: 0.55rem;
  padding-bottom: 0.5rem;
}
.tutorial-form-page .fl textarea.form-control {
  resize: vertical;
}
.tutorial-form-page .fl-group {
  margin-bottom: 20px;
}
.tutorial-form-page .fl-group-label {
  margin-bottom: 8px;
  font-size: 0.92rem;
  font-weight: 500;
}
.tutorial-form-page .editor-card part-input,
.tutorial-form-page .editor-card part-textarea,
.tutorial-form-page .editor-card part-select,
.tutorial-form-page .editor-card part-date,
.tutorial-form-page .editor-card part-file-upload,
.tutorial-form-page .editor-card part-checkbox,
.tutorial-form-page .editor-card part-radio {
  display: block;
  margin-bottom: 16px;
}
.tutorial-form-page .editor-card part-input::part(input),
.tutorial-form-page .editor-card part-textarea::part(textarea),
.tutorial-form-page .editor-card part-select::part(select),
.tutorial-form-page .editor-card part-date::part(input),
.tutorial-form-page .editor-card part-file-upload::part(zone) {
  border-radius: 8px;
}
.tutorial-form-page .editor-card part-input:last-child,
.tutorial-form-page .editor-card part-textarea:last-child,
.tutorial-form-page .editor-card part-select:last-child,
.tutorial-form-page .editor-card part-date:last-child,
.tutorial-form-page .editor-card part-file-upload:last-child,
.tutorial-form-page .editor-card part-checkbox:last-child,
.tutorial-form-page .editor-card part-radio:last-child {
  margin-bottom: 0;
}
.tutorial-form-page .step-title-part part-input,
.tutorial-form-page .section-title-part part-input {
  margin-bottom: 0;
}
.tutorial-form-page .source-radio {
  margin-bottom: 22px;
}
.tutorial-form-page .page-range {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tutorial-form-page .page-range .form-control {
  width: 90px;
  text-align: center;
}
.tutorial-form-page .page-range span {
  color: var(--muted);
}
.tutorial-form-page .scan-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
.tutorial-form-page .btn-scan {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 16px;
  border-radius: 6px;
  background: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: left;
}
.tutorial-form-page .scan-description {
  color: var(--muted);
  font-size: 0.8rem;
  max-width: 440px;
}
.tutorial-form-page .overview-empty {
  color: var(--muted);
  font-size: 0.88rem;
  margin: 6px 0 0;
}
.tutorial-form-page .tutorial-form-carousel-track {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  transition: transform 0.4s ease;
  width: 100%;
}
.tutorial-form-page .tutorial-form-slide {
  flex: 0 0 100%;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0 4px;
  box-sizing: border-box;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.tutorial-form-page .tutorial-form-slide[active] {
  height: auto;
  overflow: visible;
  visibility: visible;
}
.tutorial-form-page .tutorial-form-slide .row > [class*=col-] {
  min-width: 0;
}
@media (max-width: 768px) {
  .tutorial-form-page {
    padding: 16px;
  }
  .tutorial-form-page .tutorial-form-editor {
    grid-template-columns: minmax(0, 1fr);
  }
  .tutorial-form-page .tutorial-form-carousel {
    grid-column: 1;
    grid-row: 2;
  }
  .tutorial-form-page tutorial-slide-nav {
    grid-column: 1;
    grid-row: 1;
  }
  .tutorial-form-page tutorial-slide-section-nav {
    grid-column: 1;
    grid-row: 3;
  }
  .tutorial-form-page .page-header,
  .tutorial-form-page .slide-step .d-flex.justify-content-between {
    flex-wrap: wrap;
    gap: 12px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .tutorial-form-page .tutorial-form-carousel-track {
    transition: none;
  }
}

.tutorial_chat_widget {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  z-index: 1000;
  font-family: inherit;
  width: 48px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  height: 480px;
}
.tutorial_chat_widget.open {
  width: 428px;
}
.tutorial_chat_widget .drawer-toggler {
  top: 50%;
  z-index: 2;
}
.tutorial_chat_widget .drawer-toggler button {
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px 0 0 8px;
  padding: 16px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-height: 120px;
  width: 48px;
  justify-content: center;
  writing-mode: vertical-rl;
  text-orientation: mixed;
}
.tutorial_chat_widget .drawer-toggler button:hover {
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.2);
}
.tutorial_chat_widget .drawer-toggler button i {
  font-size: 16px;
  margin-bottom: 8px;
}
.tutorial_chat_widget .drawer-chat {
  position: relative;
  background: #FFF;
  border: 1px solid #e3e6f0;
  border-radius: 8px 0 0 8px;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.tutorial_chat_widget .drawer-chat app-chat {
  height: 480px;
}
.tutorial_chat_widget .drawer-chat .example-prompts {
  display: flex;
  flex-direction: column;
  gap: 8px;
  animation: example-prompts-in 0.3s ease-out;
  padding: 5px;
}
.tutorial_chat_widget .drawer-chat .example-prompts p {
  margin: 0;
  padding: 10px 14px;
  background: #f8f9fc;
  border: 1px solid #e3e6f0;
  border-left: 3px solid var(--primary-color);
  border-radius: 8px;
  color: #495057;
  font-size: 13px;
  line-height: 1.4;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.tutorial_chat_widget .drawer-chat .example-prompts p:hover {
  background: #fff;
  border-color: var(--primary-color);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transform: translateX(-2px);
}
.tutorial_chat_widget .drawer-chat .example-prompts p:active {
  transform: translateX(-2px) scale(0.98);
}
@keyframes example-prompts-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.editor-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 0.85rem;
  color: var(--muted);
  text-decoration: none;
  cursor: pointer;
}
.editor-back:hover {
  color: var(--brand);
}

.editor-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.editor-head h1 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 2px;
  color: var(--ink);
}
.editor-head p {
  margin: 0;
  color: var(--muted);
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.editor-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.editor-actions .btn {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
}
.editor-actions .btn-brand {
  background: var(--action);
  border-color: var(--action);
  color: #fff;
}
.editor-actions .btn-brand:hover {
  background: var(--action-dark);
  border-color: var(--action-dark);
}
.editor-actions .btn-outline-brand {
  color: var(--action);
  border-color: var(--action);
  background: #fff;
}
.editor-actions .btn-outline-brand:hover {
  background: var(--action);
  color: #fff;
}

.editor-card {
  background: #fff;
  border: 1px solid var(--brand-border);
  border-radius: 14px;
  padding: 22px;
  margin-bottom: 24px;
}

.editor-card:has(> .editor-card-title) {
  padding-top: 22px;
}

.editor-card-head {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  margin-bottom: 20px;
}
.editor-card-head h2 {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 4px 0 2px;
  color: var(--ink);
}
.editor-card-head p {
  margin: 0;
  color: var(--muted);
  font-size: 0.85rem;
}

.editor-card .form-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--muted);
  margin-bottom: 4px;
}

.step-pill,
.sp-num,
.sec-num {
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--brand-soft);
  color: var(--brand-dark);
  font-weight: 700;
}

.step-pill {
  width: 40px;
  height: 40px;
  font-size: 1rem;
}

.sp-num {
  width: 30px;
  height: 30px;
  font-size: 0.82rem;
}

.sec-num {
  width: 26px;
  height: 26px;
  font-size: 0.78rem;
  background: #fff;
  border: 1px solid var(--brand-border);
  color: var(--ink);
}

.tool-group {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.btn-tool {
  width: 34px;
  height: 34px;
  padding: 0;
  display: inline-grid;
  place-items: center;
  border: 1px solid var(--brand-border);
  border-radius: 6px;
  background: #fff;
  color: var(--muted);
  cursor: pointer;
}
.btn-tool:hover {
  border-color: var(--action);
  color: var(--action);
}
.btn-tool.is-danger:hover {
  border-color: var(--wf-red);
  color: var(--wf-red);
  background: #fdecec;
}
.btn-tool:disabled {
  opacity: 0.35;
}

.btn-link-brand {
  padding: 2px 6px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--action);
  border: 0;
  background: transparent;
  cursor: pointer;
}
.btn-link-brand:hover {
  color: var(--brand-dark);
  background: var(--brand-soft);
}

.add-dashed {
  width: 100%;
  margin-top: 14px;
  padding: 11px;
  border: 1.5px dashed #c9ced8;
  border-radius: 10px;
  background: transparent;
  color: var(--action);
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
}
.add-dashed:hover {
  border-color: var(--brand);
  color: var(--brand-dark);
  background: var(--brand-soft);
}

.overview {
  margin-top: 26px;
  padding-top: 20px;
  border-top: 1px solid var(--brand-border);
}

.overview-head {
  font-weight: 700;
  font-size: 0.95rem;
  margin-bottom: 10px;
}

.count {
  display: inline-block;
  min-width: 22px;
  padding: 0 7px;
  margin-left: 4px;
  border-radius: 999px;
  background: var(--bg);
  color: var(--muted);
  font-size: 0.75rem;
  font-weight: 700;
  text-align: center;
}

.overview-step {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 6px;
  border: 1px solid var(--brand-border);
  border-radius: 10px;
  background: #fff;
  text-align: left;
  color: var(--ink);
  cursor: pointer;
}
.overview-step:hover {
  border-color: var(--brand);
  background: #fbfefd;
}

.sp-count {
  flex-shrink: 0;
  padding: 2px 9px;
  border-radius: 999px;
  background: var(--brand-soft);
  color: var(--brand-dark);
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
}

.section-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.section-edit {
  border: 1px solid var(--brand-border);
  border-radius: 12px;
  background: #fafbfc;
  overflow: hidden;
}

.section-edit-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #fff;
  border-bottom: 1px solid var(--brand-border);
}

.section-edit-head .section-title-part::part(input) {
  border-color: transparent;
  background: transparent;
  font-weight: 600;
}

.section-edit-body {
  padding: 14px 16px 16px;
}

.section-edit-body part-textarea {
  margin-bottom: 12px;
}

.step-title-part::part(input) {
  font-size: 1.05rem;
  font-weight: 600;
  height: 40px;
  border: 1px solid transparent;
  border-radius: 8px;
  color: var(--ink);
  background: transparent;
}

.step-title-part::part(input):focus {
  border-color: var(--brand-border);
  background: #fff;
  outline: none;
}

.sub-block {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px dashed var(--brand-border);
}

.sub-block-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 0.84rem;
  font-weight: 600;
}

.task-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
}

.task-edit {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 3fr) 34px;
  gap: 6px;
  align-items: center;
}
.task-edit part-input {
  margin-bottom: 0;
}

@media (max-width: 575px) {
  .task-edit {
    grid-template-columns: minmax(0, 1fr) 34px;
  }
  .task-edit part-input[name^=todo-desc-] {
    grid-column: 1;
    grid-row: 2;
  }
}
.file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.file-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 4px 4px 4px 10px;
  border: 1px solid var(--brand-border);
  border-radius: 8px;
  background: #fff;
  font-size: 0.82rem;
}
.file-chip > i {
  color: var(--brand);
}
.file-chip .fc-name {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-chip button {
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: var(--muted);
  cursor: pointer;
}
.file-chip button:hover {
  background: #fdecec;
  color: var(--wf-red);
}

.section-file-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.section-file-row {
  display: flex;
  flex: 1 1 360px;
  gap: 10px;
  align-items: center;
  padding: 10px;
  border: 1px solid var(--brand-border);
  border-radius: 8px;
  background: #fff;
}
.section-file-row .section-file-cards {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
}
.section-file-row .section-file-card {
  flex: 1 1 220px;
  min-width: 0;
}
.section-file-row .section-file-card .section-file-card-heading {
  display: flex;
  align-items: center;
  min-height: 2.75rem;
  margin: 0 0 6px;
}
.section-file-row .section-file-mini-upload {
  margin: 0;
}
.section-file-row .section-file-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 4px;
  align-items: center;
}
@media (max-width: 700px) {
  .section-file-row {
    align-items: flex-start;
  }
  .section-file-row .section-file-mini-upload {
    flex-basis: 100%;
  }
  .section-file-row .section-file-actions {
    align-self: center;
  }
}

.section-file-modal-content {
  min-width: min(520px, 100vw - 32px);
}
.section-file-modal-content .modal-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.section-file-modal-content .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 16px 16px;
}

.editor-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1030;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
  border-top: 1px solid var(--brand-border);
  box-shadow: 0 -10px 30px -20px rgba(31, 44, 85, 0.35);
}

.editor-nav-progress {
  height: 3px;
  background: var(--brand-soft);
}
.editor-nav-progress span {
  display: block;
  height: 100%;
  width: 0;
  background: var(--brand);
  transition: width 0.25s ease;
}

.editor-nav-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.editor-nav .container.editor-nav-inner {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 24px;
  padding-right: 24px;
}

.nav-arrow {
  height: 48px;
  min-width: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 16px;
  border: 1px solid var(--action);
  border-radius: 8px;
  background: #fff;
  color: var(--action);
  font-weight: 600;
  font-size: 0.9rem;
  flex-shrink: 0;
  cursor: pointer;
}
.nav-arrow:hover {
  background: var(--action);
  border-color: var(--action);
  color: #fff;
}
.nav-arrow:disabled {
  border-color: var(--brand-border);
  color: var(--muted);
  background: #fff;
  opacity: 0.6;
}
.nav-arrow.nav-arrow-next:not(:disabled) {
  background: var(--action);
  color: #fff;
}
.nav-arrow.nav-arrow-next:not(:disabled):hover {
  background: var(--action-dark);
  border-color: var(--action-dark);
  color: #fff;
}

.picker-group {
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.editor-foot-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
  padding: 14px 18px;
  border: 1px solid var(--brand-border);
  border-radius: var(--card-radius);
  background: #fff;
}
.editor-foot-actions .efa-hint {
  min-width: 0;
  color: var(--muted);
  font-size: 0.88rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.editor-foot-actions .efa-hint strong {
  color: var(--ink);
  font-weight: 600;
}
.editor-foot-actions .editor-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.editor-foot-actions .editor-actions .btn {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
}

.editor-toast {
  position: fixed;
  left: 50%;
  bottom: 92px;
  z-index: 1040;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: calc(100vw - 32px);
  padding: 10px 16px;
  border-radius: 10px;
  background: var(--wf-navy);
  color: #fff;
  font-size: 0.9rem;
  box-shadow: 0 14px 34px -14px rgba(31, 44, 85, 0.5);
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, 10px);
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.editor-toast.show {
  opacity: 1;
  transform: translate(-50%, 0);
}
.editor-toast.is-error {
  background: var(--wf-red);
}

@media (max-width: 768px) {
  .editor-head {
    flex-wrap: wrap;
  }
  .editor-actions {
    width: 100%;
  }
  .editor-actions .btn {
    flex: 1;
    justify-content: center;
  }
  .editor-foot-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .editor-foot-actions .editor-actions .btn {
    flex: 1;
    justify-content: center;
  }
  .task-edit {
    grid-template-columns: minmax(0, 1fr) 34px;
  }
}
.modal-button {
  background: none;
  box-shadow: none;
  border: none;
}

.editor-actions part-switch {
  padding: 10px;
  border: 1px solid var(--action);
  background: #FFF;
  border-radius: 20px;
}`;
const shadowOptions = { "mode": "open" };
let TutorialForm = class TutorialForm extends client_1.RWSViewComponent {
    constructor(storageService, popupService) {
        super();
        this.storageService = storageService;
        this.popupService = popupService;
        this.webflex = false;
        this.tutorialId = null;
        this.loading = false;
        this.saving = false;
        this.availableAvatars = [];
        this.showOnboarding = false;
        this.categoryOptions = [];
        this.sourceOptions = [];
        this.knowledgeOptions = [];
        this.scanned = false;
        this.chatDrawerOpen = false;
        this.scanProgressCurrentSection = 0;
        this.scanProgressTotalSections = 0;
        this.scanProgressPhase = '';
        this.scanProgressSectionTitle = '';
        this.onboardingAttached = null;
        this.chatStarted = false;
        // New tutorials start on a chooser (onboarding or straight to the form)
        this.formStarted = false;
        this.currentStepIndex = 0;
        this.formEditorOpen = false;
        this.editingSectionFormData = null;
        this.editingFormStepIndex = null;
        this.editingFormSectionIndex = null;
        this.toastMessage = '';
        this.toastError = false;
        this.publish = false;
        this.sectionFileModalOpen = false;
        this.sectionFileModalTarget = null;
        this.pendingSectionFile = null;
        this.selectedModel = {
            provider: { name: 'google', value: 'google' },
            model: { label: 'Gemini 3.5 flash', value: 'google/gemini-3.5-flash' },
            aiProvider: 'openrouter'
        };
        this.form = {
            name: '',
            description: '',
            introText: '',
            tutorialGoal: '',
            expireAt: null,
            categoryId: null,
            active: true,
            draft: false,
            source: 'ai',
            hours: 1,
            scanKnowledgeId: null,
            scanPagesFrom: null,
            scanPagesTo: null,
            creator: null,
            avatar: null,
            logo: null,
            instructionFile: null,
            sourceFile: null
        };
        this.steps = [];
        // Bound by the ref() directive in the template
        this.chatComponent = null;
        this.scanSnapshot = null;
        this.sendSubmit = (component, context) => {
            console.log('[tutorial form] save button clicked');
            component_1.FormComponent.sendSubmitEvent(component, context);
        };
    }
    async connectedCallback() {
        var _a;
        super.connectedCallback();
        // Capture any ID already provided via attribute or current route params
        const initialTutorialId = this.tutorialId || ((_a = this.routeParams) === null || _a === void 0 ? void 0 : _a.id) || null;
        this.resetForm();
        // routeParams may not be populated yet at connection time; routeParamsChanged handles late updates
        this.tutorialId = initialTutorialId;
        if (!this.steps) {
            this.steps = [];
        }
        await Promise.all([
            this.loadAvatars(),
            this.loadKnowledgeOptions()
        ]);
        this.sourceOptions = [
            { label: 'tutorial.form.source.ai'.t(), value: 'ai', description: 'tutorial.form.source.ai.description' },
            { label: 'tutorial.form.source.file'.t(), value: 'file', description: 'tutorial.form.source.file.description' }
        ];
        // Automatically syncs form inputs to this.form
        component_1.FormComponent.listenForValuesChange.bind(this)('form', () => {
            this.updateChatTools();
        });
        TutorialFormEventsHelper_1.TutorialFormEventsHelper.bindEvents.call(this);
        if (!this.tutorialId) {
            this.steps = [];
            TutorialStepsHelper_1.TutorialStepsHelper.addStep.call(this);
            this.updateChatTools();
        }
        await this.getCategories();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resetForm();
    }
    resetForm() {
        this.tutorialId = null;
        this.loading = false;
        this.saving = false;
        this.showOnboarding = false;
        this.scanned = false;
        this.chatDrawerOpen = false;
        this.scanProgressCurrentSection = 0;
        this.scanProgressTotalSections = 0;
        this.scanProgressPhase = '';
        this.scanProgressSectionTitle = '';
        this.onboardingAttached = null;
        this.chatStarted = false;
        this.formStarted = false;
        this.currentStepIndex = 0;
        this.publish = false;
        this.scanSnapshot = null;
        this.form = {
            name: '',
            description: '',
            introText: '',
            tutorialGoal: '',
            expireAt: null,
            categoryId: null,
            active: true,
            draft: false,
            source: 'ai',
            scanKnowledgeId: null,
            scanPagesFrom: null,
            scanPagesTo: null,
            creator: null,
            avatar: null,
            logo: null,
            instructionFile: null,
            sourceFile: null,
            hours: null
        };
        this.steps = [];
    }
    tutorialIdChanged() {
        if (this.tutorialId) {
            this.formStarted = true;
            this.loadTutorial();
        }
        else {
            this.resetForm();
            TutorialStepsHelper_1.TutorialStepsHelper.addStep.call(this);
            this.updateChatTools();
        }
    }
    routeParamsChanged() {
        var _a;
        const id = ((_a = this.routeParams) === null || _a === void 0 ? void 0 : _a.id) || null;
        if (id && !this.tutorialId) {
            this.tutorialId = id;
        }
        else if (!id && this.tutorialId) {
            this.tutorialId = null;
        }
    }
    stepsChanged() {
        this.currentStepIndex = Math.min(this.currentStepIndex, this.steps.length);
        this.renderSectionSourceHtml();
    }
    formChanged() {
        this.renderSectionSourceHtml();
    }
    currentStepIndexChanged() {
        this.renderSectionSourceHtml();
        setTimeout(() => {
            var _a, _b;
            const sectionNav = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('tutorial-slide-section-nav');
            console.log('[form] currentStepIndexChanged, sectionNav', sectionNav);
            (_b = sectionNav === null || sectionNav === void 0 ? void 0 : sectionNav.setupObserver) === null || _b === void 0 ? void 0 : _b.call(sectionNav);
        }, 500);
    }
    get allSectionsFlat() {
        return TutorialStepsHelper_1.TutorialStepsHelper.getAllSectionsFlat.call(this);
    }
    get currentStepSections() {
        var _a;
        if (this.currentStepIndex <= 0 || this.currentStepIndex > this.steps.length) {
            return [];
        }
        return ((_a = this.steps[this.currentStepIndex - 1]) === null || _a === void 0 ? void 0 : _a.sections) || [];
    }
    get formSubtitle() {
        if (this.currentStepIndex === 0) {
            return 'tutorial.form.basicInfo'.t();
        }
        const step = this.steps[this.currentStepIndex - 1];
        if (!step) {
            return '';
        }
        return `${'tutorial.form.step'.t()} ${this.currentStepIndex} / ${this.steps.length} · ${step.title || ''}`;
    }
    get progressPercent() {
        return this.totalSlides > 0 ? ((this.currentStepIndex + 1) / this.totalSlides) * 100 : 0;
    }
    get currentSlideLabel() {
        if (this.currentStepIndex === 0) {
            return 'tutorial.form.basicInfo'.t();
        }
        const step = this.steps[this.currentStepIndex - 1];
        return (step === null || step === void 0 ? void 0 : step.title) || `${'tutorial.form.step'.t()} ${this.currentStepIndex}`;
    }
    get slideMenuItems() {
        const items = [
            {
                index: 0,
                label: 'tutorial.form.basicInfo'.t(),
                sectionsLabel: '',
                active: this.currentStepIndex === 0
            }
        ];
        this.steps.forEach((step, i) => {
            items.push({
                index: i + 1,
                label: step.title || `${'tutorial.form.step'.t()} ${i + 1}`,
                sectionsLabel: `${step.sections.length} ${'tutorial.form.sections'.t()}`,
                active: this.currentStepIndex === i + 1
            });
        });
        return items;
    }
    get sectionMenuItems() {
        if (this.currentStepIndex <= 0 || this.currentStepIndex > this.steps.length) {
            return [];
        }
        const step = this.steps[this.currentStepIndex - 1];
        if (!step) {
            return [];
        }
        return step.sections.map((section, i) => ({
            index: i,
            label: section.title || `${'tutorial.form.section'.t()} ${i + 1}`,
            tasksCount: (section.todoItems || []).length,
            active: true
        }));
    }
    sectionCountLabel(step) {
        var _a, _b;
        const n = ((_a = step.sections) === null || _a === void 0 ? void 0 : _a.length) || 0;
        const t = ((_b = step.sections) === null || _b === void 0 ? void 0 : _b.reduce((sum, s) => { var _a; return sum + (((_a = s.todoItems) === null || _a === void 0 ? void 0 : _a.length) || 0); }, 0)) || 0;
        return `${n} ${'tutorial.form.sections'.t()} · ${t} ${'tutorial.form.todoItems'.t()}`;
    }
    attachmentsCount(section) {
        var _a;
        let count = ((_a = section.tutorialSectionFiles) === null || _a === void 0 ? void 0 : _a.length) || 0;
        if (section.screenshot)
            count++;
        if (section.video)
            count++;
        if (section.screenshotMini)
            count++;
        if (section.videoMini)
            count++;
        return count;
    }
    openSectionFileModal(stepIndex, sectionIndex, fileIndex = null) {
        var _a, _b, _c;
        const existing = fileIndex === null
            ? null
            : (_c = (_b = (_a = this.steps[stepIndex]) === null || _a === void 0 ? void 0 : _a.sections[sectionIndex]) === null || _b === void 0 ? void 0 : _b.tutorialSectionFiles) === null || _c === void 0 ? void 0 : _c[fileIndex];
        this.sectionFileModalTarget = { stepIndex, sectionIndex, fileIndex };
        this.pendingSectionFile = existing
            ? { ...existing }
            : { file: null, mini: null };
        this.sectionFileModalOpen = true;
    }
    closeSectionFileModal() {
        this.sectionFileModalOpen = false;
        this.sectionFileModalTarget = null;
        this.pendingSectionFile = null;
    }
    handleSectionFileUpload(event) {
        const file = Array.isArray(event.data) ? event.data[0] : event.data;
        if (file && this.pendingSectionFile) {
            this.pendingSectionFile = { ...this.pendingSectionFile, file };
        }
    }
    handleSectionFileMiniUpload(event) {
        const file = Array.isArray(event.data) ? event.data[0] : event.data;
        if (file && this.pendingSectionFile) {
            this.pendingSectionFile = { ...this.pendingSectionFile, mini: file };
        }
    }
    saveSectionFile() {
        var _a;
        const target = this.sectionFileModalTarget;
        const pending = this.pendingSectionFile;
        if (!target || !(pending === null || pending === void 0 ? void 0 : pending.file)) {
            this.popupService.error('tutorial.form.sectionFileRequired'.t());
            return;
        }
        const section = (_a = this.steps[target.stepIndex]) === null || _a === void 0 ? void 0 : _a.sections[target.sectionIndex];
        if (!section) {
            this.popupService.error('tutorial.saveFailed'.t());
            return;
        }
        const sectionFiles = [...(section.tutorialSectionFiles || [])];
        const savedFile = {
            ...pending,
            file: pending.file
        };
        if (target.fileIndex === null) {
            sectionFiles.push(savedFile);
        }
        else if (target.fileIndex >= 0 && target.fileIndex < sectionFiles.length) {
            sectionFiles[target.fileIndex] = savedFile;
        }
        else {
            this.popupService.error('tutorial.saveFailed'.t());
            return;
        }
        const sections = [...this.steps[target.stepIndex].sections];
        sections[target.sectionIndex] = { ...section, tutorialSectionFiles: sectionFiles };
        const steps = [...this.steps];
        steps[target.stepIndex] = { ...steps[target.stepIndex], sections };
        this.steps = steps;
        this.closeSectionFileModal();
    }
    removeSectionFile(stepIndex, sectionIndex, fileIndex) {
        var _a;
        const section = (_a = this.steps[stepIndex]) === null || _a === void 0 ? void 0 : _a.sections[sectionIndex];
        if (!(section === null || section === void 0 ? void 0 : section.tutorialSectionFiles)) {
            return;
        }
        const sectionFiles = section.tutorialSectionFiles.filter((_, index) => index !== fileIndex);
        const sections = [...this.steps[stepIndex].sections];
        sections[sectionIndex] = { ...section, tutorialSectionFiles: sectionFiles };
        const steps = [...this.steps];
        steps[stepIndex] = { ...steps[stepIndex], sections };
        this.steps = steps;
    }
    handleInlineSectionFileMiniUpload(stepIndex, sectionIndex, fileIndex, event) {
        var _a, _b;
        const file = Array.isArray(event.data) ? event.data[0] : event.data;
        const section = (_a = this.steps[stepIndex]) === null || _a === void 0 ? void 0 : _a.sections[sectionIndex];
        const sectionFile = (_b = section === null || section === void 0 ? void 0 : section.tutorialSectionFiles) === null || _b === void 0 ? void 0 : _b[fileIndex];
        if (!file || !section || !sectionFile) {
            return;
        }
        const sectionFiles = [...(section.tutorialSectionFiles || [])];
        sectionFiles[fileIndex] = { ...sectionFile, mini: file };
        const sections = [...this.steps[stepIndex].sections];
        sections[sectionIndex] = { ...section, tutorialSectionFiles: sectionFiles };
        const steps = [...this.steps];
        steps[stepIndex] = { ...steps[stepIndex], sections };
        this.steps = steps;
    }
    // Data loading
    loadAvatars() {
        return TutorialDataHelper_1.TutorialDataHelper.loadAvatars.call(this);
    }
    loadKnowledgeOptions() {
        return TutorialDataHelper_1.TutorialDataHelper.loadKnowledgeOptions.call(this);
    }
    loadTutorial() {
        return TutorialDataHelper_1.TutorialDataHelper.loadTutorial.call(this);
    }
    getCategories() {
        return TutorialDataHelper_1.TutorialDataHelper.getCategories.call(this);
    }
    // Steps, sections and todo items
    renderSectionSourceHtml() {
        TutorialStepsHelper_1.TutorialStepsHelper.renderSectionSourceHtml.call(this);
    }
    addStep() {
        console.log('[form addStep] called');
        TutorialStepsHelper_1.TutorialStepsHelper.addStep.call(this);
        console.log('[form addStep] steps.length now:', this.steps.length);
        this.currentStepIndex = this.steps.length;
        console.log('[form addStep] currentStepIndex set to:', this.currentStepIndex);
        setTimeout(() => {
            var _a;
            const slide = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.tutorial-form-slide.slide-step[active]');
            const sectionEl = slide === null || slide === void 0 ? void 0 : slide.querySelector('.section-edit[data-section-index="0"]');
            sectionEl === null || sectionEl === void 0 ? void 0 : sectionEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const titleInput = sectionEl === null || sectionEl === void 0 ? void 0 : sectionEl.querySelector('.section-title-part input');
            titleInput === null || titleInput === void 0 ? void 0 : titleInput.focus({ preventScroll: true });
        }, 0);
    }
    removeStep(stepIndex) {
        const currentIndex = this.currentStepIndex;
        const previousLength = this.steps.length;
        TutorialStepsHelper_1.TutorialStepsHelper.removeStep.call(this, stepIndex);
        if (this.steps.length < previousLength) {
            this.currentStepIndex = Math.min(currentIndex - (stepIndex + 1 < currentIndex ? 1 : 0), this.steps.length);
        }
    }
    moveStepUp(stepIndex) {
        TutorialStepsHelper_1.TutorialStepsHelper.moveStepUp.call(this, stepIndex);
        if (stepIndex > 0 && stepIndex < this.steps.length) {
            if (this.currentStepIndex === stepIndex + 1) {
                this.currentStepIndex--;
            }
            else if (this.currentStepIndex === stepIndex) {
                this.currentStepIndex++;
            }
        }
    }
    moveStepDown(stepIndex) {
        TutorialStepsHelper_1.TutorialStepsHelper.moveStepDown.call(this, stepIndex);
        if (stepIndex >= 0 && stepIndex < this.steps.length - 1) {
            if (this.currentStepIndex === stepIndex + 1) {
                this.currentStepIndex++;
            }
            else if (this.currentStepIndex === stepIndex + 2) {
                this.currentStepIndex--;
            }
        }
    }
    updateStepField(stepIndex, field, value) {
        TutorialStepsHelper_1.TutorialStepsHelper.updateStepField.call(this, stepIndex, field, value);
    }
    updateSectionField(stepIndex, sectionIndex, field, value) {
        TutorialStepsHelper_1.TutorialStepsHelper.updateSectionField.call(this, stepIndex, sectionIndex, field, value);
    }
    addSectionToStep(stepIndex) {
        TutorialStepsHelper_1.TutorialStepsHelper.addSectionToStep.call(this, stepIndex);
    }
    removeSectionFromStep(stepIndex, sectionIndex) {
        TutorialStepsHelper_1.TutorialStepsHelper.removeSectionFromStep.call(this, stepIndex, sectionIndex);
    }
    moveSectionUp(stepIndex, sectionIndex) {
        TutorialStepsHelper_1.TutorialStepsHelper.moveSectionUp.call(this, stepIndex, sectionIndex);
    }
    moveSectionDown(stepIndex, sectionIndex) {
        TutorialStepsHelper_1.TutorialStepsHelper.moveSectionDown.call(this, stepIndex, sectionIndex);
    }
    handleSectionKnowledgeChange(stepIndex, sectionIndex, knowledgeIds) {
        TutorialStepsHelper_1.TutorialStepsHelper.handleSectionKnowledgeChange.call(this, stepIndex, sectionIndex, knowledgeIds);
    }
    handleSectionFileChange(stepIndex, sectionIndex, fileType, file) {
        TutorialStepsHelper_1.TutorialStepsHelper.handleSectionFileChange.call(this, stepIndex, sectionIndex, fileType, file);
    }
    getSectionsForStep(stepIndex) {
        return TutorialStepsHelper_1.TutorialStepsHelper.getSectionsForStep.call(this, stepIndex);
    }
    addTodoItem(stepIndex, sectionIndex) {
        TutorialStepsHelper_1.TutorialStepsHelper.addTodoItem.call(this, stepIndex, sectionIndex);
    }
    removeTodoItem(stepIndex, sectionIndex, todoIndex) {
        TutorialStepsHelper_1.TutorialStepsHelper.removeTodoItem.call(this, stepIndex, sectionIndex, todoIndex);
    }
    updateTodoItem(stepIndex, sectionIndex, todoIndex, field, value) {
        TutorialStepsHelper_1.TutorialStepsHelper.updateTodoItem.call(this, stepIndex, sectionIndex, todoIndex, field, value);
    }
    scrollToStep(stepIndex) {
        TutorialStepsHelper_1.TutorialStepsHelper.scrollToStep.call(this, stepIndex);
    }
    openFormEditor(stepIndex, sectionIndex) {
        var _a;
        const section = (_a = this.steps[stepIndex]) === null || _a === void 0 ? void 0 : _a.sections[sectionIndex];
        this.editingFormStepIndex = stepIndex;
        this.editingFormSectionIndex = sectionIndex;
        const rawFormData = section === null || section === void 0 ? void 0 : section.formData;
        let formData;
        if (rawFormData && typeof rawFormData === 'object') {
            formData = JSON.parse(JSON.stringify(rawFormData));
        }
        else {
            formData = { fields: [], submitLabel: '' };
        }
        this.editingSectionFormData = formData;
        this.formEditorOpen = true;
    }
    onFormEditorClose() {
        this.formEditorOpen = false;
        this.editingFormStepIndex = null;
        this.editingFormSectionIndex = null;
        this.editingSectionFormData = null;
    }
    handleFormEditorChanged(event) {
        if (this.editingFormStepIndex === null || this.editingFormSectionIndex === null) {
            return;
        }
        const stepIndex = this.editingFormStepIndex;
        const sectionIndex = this.editingFormSectionIndex;
        const section = this.steps[stepIndex].sections[sectionIndex];
        this.steps[stepIndex].sections[sectionIndex] = { ...section, formData: event.detail };
        this.steps = [...this.steps];
        this.updateChatTools();
    }
    handleFormEditorSave(event) {
        this.handleFormEditorChanged(event);
        this.onFormEditorClose();
    }
    scrollToSection(sectionIndex) {
        TutorialStepsHelper_1.TutorialStepsHelper.scrollToSection.call(this, sectionIndex);
    }
    goToStep(index) {
        if (index >= 0 && index < this.totalSlides) {
            this.currentStepIndex = index;
        }
    }
    nextStep() {
        this.goToStep(this.currentStepIndex + 1);
    }
    prevStep() {
        this.goToStep(this.currentStepIndex - 1);
    }
    get totalSlides() {
        return 1 + this.steps.length;
    }
    get canGoNext() {
        return this.currentStepIndex < this.totalSlides - 1;
    }
    get canGoPrev() {
        return this.currentStepIndex > 0;
    }
    // Save and scan
    handleSubmit(event) {
        return TutorialSaveHelper_1.TutorialSaveHelper.handleSubmit.call(this, event);
    }
    handlePublishChange(_event, value) {
        this.publish = value;
    }
    scanSourceFile(force = false) {
        return TutorialScanHelper_1.TutorialScanHelper.scanSourceFile.call(this, force);
    }
    async regenerateFromPdf() {
        const confirmed = await this.popupService.confirm('tutorial.form.regenerateFromPdf.confirm'.t(), false, 'tutorial.form.regenerateFromPdf.title'.t());
        if (!confirmed) {
            return;
        }
        await this.scanSourceFile(true);
    }
    onLogoUpload(event) {
        this.form.logo = event.data;
        this.form = { ...this.form };
    }
    onSourceFileUpload(event) {
        this.form.sourceFile = event.data;
        if (event.data) {
            this.form.scanKnowledgeId = null;
        }
        this.form = { ...this.form };
    }
    // Assistant chat
    toggleChatDrawer() {
        this.chatDrawerOpen = !this.chatDrawerOpen;
        // The chat is rendered only once the form is shown, so refresh its tool data when the drawer is used
        this.updateChatTools();
    }
    updateChatTools() {
        TutorialChatHelper_1.TutorialChatHelper.updateChatTools.call(this);
    }
    runExamplePrompt(prompt) {
        TutorialChatHelper_1.TutorialChatHelper.runExamplePrompt.call(this, prompt);
    }
    applyToolFormData(toolData) {
        TutorialChatHelper_1.TutorialChatHelper.applyToolFormData.call(this, toolData);
    }
    // Navigation
    openOnboarding() {
        this.showOnboarding = true;
    }
    closeOnboarding() {
        this.showOnboarding = false;
    }
    startForm() {
        this.formStarted = true;
    }
    showToast(message, error = false) {
        this.toastMessage = message;
        this.toastError = error;
        setTimeout(() => {
            this.toastMessage = '';
            this.toastError = false;
        }, 2800);
    }
    cancel() {
        component_2.SiteMenu.goto.bind(this)('/tutorial/list');
    }
};
exports.TutorialForm = TutorialForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialForm.prototype, "webflex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialForm.prototype, "tutorialId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialForm.prototype, "saving", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialForm.prototype, "availableAvatars", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialForm.prototype, "showOnboarding", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof Array !== "undefined" && Array) === "function" ? _c : Object)
], TutorialForm.prototype, "categoryOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof Array !== "undefined" && Array) === "function" ? _d : Object)
], TutorialForm.prototype, "sourceOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof Array !== "undefined" && Array) === "function" ? _e : Object)
], TutorialForm.prototype, "knowledgeOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialForm.prototype, "scanned", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialForm.prototype, "chatDrawerOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialForm.prototype, "scanProgressCurrentSection", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialForm.prototype, "scanProgressTotalSections", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialForm.prototype, "scanProgressPhase", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialForm.prototype, "scanProgressSectionTitle", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof backendImport_1.ONBOARDING !== "undefined" && backendImport_1.ONBOARDING.ITutorialOnboardingPayload) === "function" ? _f : Object)
], TutorialForm.prototype, "onboardingAttached", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialForm.prototype, "chatStarted", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialForm.prototype, "formStarted", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialForm.prototype, "currentStepIndex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialForm.prototype, "formEditorOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialForm.prototype, "editingSectionFormData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialForm.prototype, "editingFormStepIndex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialForm.prototype, "editingFormSectionIndex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialForm.prototype, "toastMessage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialForm.prototype, "toastError", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialForm.prototype, "publish", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialForm.prototype, "sectionFileModalOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialForm.prototype, "sectionFileModalTarget", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_g = typeof tutorial_form_types_2.ITutorialSectionFileDraft !== "undefined" && tutorial_form_types_2.ITutorialSectionFileDraft) === "function" ? _g : Object)
], TutorialForm.prototype, "pendingSectionFile", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_h = typeof backendImport_1.ISelectedModel !== "undefined" && backendImport_1.ISelectedModel) === "function" ? _h : Object)
], TutorialForm.prototype, "selectedModel", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_j = typeof tutorial_form_types_1.ITutorialFormData !== "undefined" && tutorial_form_types_1.ITutorialFormData) === "function" ? _j : Object)
], TutorialForm.prototype, "form", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialForm.prototype, "steps", void 0);
exports.TutorialForm = TutorialForm = __decorate([
    (0, client_1.RWSView)('tutorial-form', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(StorageService_1.default)),
    __param(1, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _a : Object, typeof (_b = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _b : Object])
], TutorialForm);
TutorialForm.defineComponent();
